import script from "./SettingOdds.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingOdds.vue?vue&type=script&setup=true&lang=js"

import "./SettingOdds.vue?vue&type=style&index=0&id=a275fd12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a275fd12"]])

export default __exports__